import type { Sources } from './types';
import { createFirestoreLive } from './firestore';
import { createHttpQuery, listPoolKeys, listTenantKeys } from './http';
import { listMemories, memoryStats, memoryTenants, recallMemories } from '../../api/memory';

/** The signed-in console's sources.
 *
 *  Assembled here so the two lanes stay visibly separate: rows are Firestore
 *  watches under the operator's own identity, and the warehouse plus the two
 *  secret-bearing collections are authenticated HTTP. Nothing above the source
 *  layer knows which is which. */
export function createRealSources(): Sources {
  const live = createFirestoreLive();
  return {
    live: {
      ...live,
      // Not watches, and never will be: a Firestore rule grants a whole
      // document, and these two collections carry a raw OAuth payload and a
      // sealed key reference (DR-28).
      listPoolKeys,
      listTenantKeys,
      // Nor these (DR-75): memory text is agent-written tenant content.
      listMemories,
      memoryStats,
      memoryTenants,
      recallMemories,
    },
    query: createHttpQuery(),
    // Writes land in a later pass; the console keeps its honest disabled state
    // with a reason until they do, rather than offering a control that fails.
    canMutate: false,
  };
}
